import  { queryToString, getQueryStringPair } from './modules/query-url'

const wpslSearch = () => {

	const url = new URL(window.location);
	const params = new URLSearchParams(window.location.search);
	const searchQuery = params.get('wpsl_search');
	let initialLoad = true

	const wpsl = document.getElementById('wpsl-wrap');
	const searchForm = wpsl.querySelector('.wpsl-search form');
	const searchField = searchForm.querySelector('input[name="wpsl-search-input"]');
	const submitButton = searchForm.querySelector('#wpsl-search-btn');

	// Declare a fragment:
	let fragment = document.createDocumentFragment();

	// Append desired element to the fragment:
	fragment.appendChild(document.querySelector('.tingle-modal__close'));

	// Append fragment to desired element:
	document.querySelector('.tingle-modal-box').appendChild(fragment);

	submitButton.addEventListener('click', (e) => {
		if (!initialLoad) {
            
			const queryParams = getQueryStringPair(window.location.search);
			queryParams.wpsl_search = searchField.value;
			
			history.replaceState(null, null, `?${queryToString(queryParams)}`);
			
			console.log("history",history);
		}
		initialLoad = false
		e.preventDefault();
	});

	['change'].forEach((e) => {
		searchField.addEventListener(e, _.debounce(() => {
			submitButton.click();
		}, 500))
	})

	if (params.has('wpsl_search')) {
		wpsl.style.visibility = 'hidden';
		setTimeout(() => {
			searchField.value = searchQuery;
			submitButton.click();

			wpsl.style.visibility = 'visible';

		}, 500);
	} else {
		initialLoad = false
	}
}

window.addEventListener('DOMContentLoaded', () => {
    wpslSearch()
} );